import { render, staticRenderFns } from "./picture.vue?vue&type=template&id=f13de21a&scoped=true&"
import script from "./picture.vue?vue&type=script&lang=js&"
export * from "./picture.vue?vue&type=script&lang=js&"
import style0 from "./picture.vue?vue&type=style&index=0&id=f13de21a&prod&lang=css&"
import style1 from "./picture.vue?vue&type=style&index=1&id=f13de21a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13de21a",
  null
  
)

export default component.exports